<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>Aulas Experimentais Agendadas</h6>
        <i class="bi bi-x-circle close-icon" @click="$emit('fechar')" title="Fechar"></i>
      </div>

      <!-- Tabela de Aulas -->
      <div class="table-container">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Aluno</th>
              <th>Turma</th>
              <th>Status</th>
              <th>Agendamento</th>
              <th>Observações</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="!aulas.length">
              <td colspan="6" class="text-center">Nenhuma aula experimental nesta semana.</td>
            </tr>

            <tr v-else v-for="item in aulas" :key="item.prospeccao_id">
              <td>
                {{ item.nome_aluno }}
                <span v-if="item.idade !== null && item.idade !== undefined">
                  ({{ item.idade }} {{ item.idade === 1 ? 'ano' : 'anos' }})
                </span>
              </td>

              <td>{{ item.turma_completa }}</td>

              <td>
                <span :class="statusClass(item.status)">{{ item.status }}</span>
              </td>

              <td class="text-primary">{{ formatarData(item.data_aula) }}</td>

              <!-- ✅ NOVO -->
              <td class="obs-col" :title="item.observacoes || ''">
                {{ item.observacoes || '—' }}
              </td>

              <td class="text-center">
                <i
                  class="bi bi-arrow-right-circle action-icon"
                  title="Detalhar Prospeccao"
                  @click="detalhar(item.prospeccao_id)"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import globalUtils from '@/utils/globalUtils';

export default {
  name: 'AulasExperimentaisSemana',
  props: {
    mostrar: {
      type: Boolean,
      default: false
    },
    aulas: {
      type: Array,
      default: () => []
    }
  },
  emits: ['fechar'],
  methods: {
    detalhar(id) {
      this.$emit('fechar');
      this.$router.push({ name: 'DetalharProspeccao', params: { id } });
    },
    formatarData(data) {
      return globalUtils.formatarData(data);
    },
    statusClass(status) {
      // status: 'Agendada', 'Reagendada' ou 'Confirmada'
      if (status === 'Confirmada') {
        return 'text-success';
      }
      // para 'Agendada' ou 'Reagendada'
      return 'text-warning';
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  width: 100%;
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 4px;
  z-index: 2001;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f1f1f1;
  border-bottom: 1px solid #ddd;
}

.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}

.table-container {
  padding: 15px;
}

.table th,
.table td {
  vertical-align: middle;
}

.action-icon {
  cursor: pointer;
  font-size: 1.2rem;
  color: #007bff;
}

action-icon:hover {
  color: #0056b3;
}

/* Text colors */
.text-success {
  color: #28a745 !important;
}

.text-warning {
  color: #ffc107 !important;
}

.obs-col{
  max-width: 320px;
  white-space: normal;
  word-break: break-word;
}

</style>
